import { TRIAL_BALANCE_TABS } from 'constants/util/side-by-side-utils';
import { handleActions } from 'redux-actions';
import { resetMappedElements } from 'store/actions/trial-balance/mapped-element-action';
import {
  setElementToScrollInTrialBalanceView,
  setTrialBalanceTableTab,
} from 'store/actions/trial-balance/trial-balance-action';

export default handleActions(
  {
    [setTrialBalanceTableTab]: (state, { payload }) => {
      return { ...state, selectedTab: payload };
    },
    [setElementToScrollInTrialBalanceView]: (state, { payload }) => {
      return { ...state, elementToScroll: payload };
    },
    [resetMappedElements]: (state) => {
      return { ...state, elementToScroll: {} };
    },
  },
  {
    selectedTab: TRIAL_BALANCE_TABS.balanceSheet,
    elementToScroll: {},
  },
);
